module.exports = __webpack_public_path__ + "static/5-724e655b2de9aa66c1e703813c62bb7e.png";